/**
 * @author cardo
 * @description
 * define layout Thema
 */
export function layoutThema(type: any) {
    const bgFontThema = {
        bgColor: '',
        fontColor: '',
    }
    switch (type) {
        case 0:
            bgFontThema.bgColor = '#fff'
            bgFontThema.fontColor = '#000'
            break
        case 1:
            bgFontThema.bgColor = '#000'
            bgFontThema.fontColor = '#fff'
            break
        default:
            bgFontThema.bgColor = '#fff'
            bgFontThema.fontColor = '#000'
            break
    }
    return bgFontThema
}

/**
 * @author cardo
 * @description
 * api 호출 주소 정의
 * Cardo HOMEPAGE : CH
 * baseURL 정의 : cra의 env 순서
 */
export const baseURL = process.env.REACT_APP_STO_USER_API

/**
 * @author cardo
 * @description
 * accessToken  data
 */
export function accessToken() {
    const accessToken = window.sessionStorage.getItem('authToken')
    if (accessToken === undefined || accessToken === null) {
        return ''
    } else return accessToken
}

/**
 *
 * @author cardo
 * @description
 * define URL Method Type
 * Cardo HOMEPAGE : CH
 */
export enum CH_USER_URL {
    homeURL = '/', // 홈 주소
}

/**
 * @author cardo
 * @description
 * define API Method Type
 * Cardo HOMEPAGE : CH
 */
export enum CH_USER_API {
    homeAPI = '/home',
}
